import { useEffect, useState } from 'react'

import {
  LAYOUT_COMPACT_MAX_WIDTH,
  SPLIT_LAYOUT_MIN_HEIGHT,
  SPLIT_LAYOUT_MIN_WIDTH
} from '@/constants/layout'

const compactMediaQuery = `(max-width: ${LAYOUT_COMPACT_MAX_WIDTH}px)`

const getIsCompact = () => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false
  }
  return window.matchMedia(compactMediaQuery).matches
}

const getIsSplitDesktop = () => {
  if (typeof window === 'undefined') return false
  return (
    window.innerWidth >= SPLIT_LAYOUT_MIN_WIDTH && window.innerHeight >= SPLIT_LAYOUT_MIN_HEIGHT
  )
}

/**
 * Shared responsive layout breakpoints for auth-flux shells.
 * - isCompact: mobile/tablet card/header rules (≤767px)
 * - isSplitDesktop: SplitLayout left panel + hide header on login/OTP (≥1200×700)
 */
export default function useLayoutBreakpoints() {
  const [isCompact, setIsCompact] = useState(getIsCompact)
  const [isSplitDesktop, setIsSplitDesktop] = useState(getIsSplitDesktop)
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined

    const mediaQuery = window.matchMedia(compactMediaQuery)
    const sync = () => {
      setIsCompact(mediaQuery.matches)
      setIsSplitDesktop(getIsSplitDesktop())
      setIsLoaded(true)
    }

    sync()
    mediaQuery.addEventListener('change', sync)
    window.addEventListener('resize', sync)

    return () => {
      mediaQuery.removeEventListener('change', sync)
      window.removeEventListener('resize', sync)
    }
  }, [])

  return { isCompact, isSplitDesktop, isLoaded }
}
